// src/components/LoadingModal.js
import { useState, useEffect } from "react";
import "../styles/loadingModal.css";

export default function LoadingModal({ open }) {
  if (!open) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-box">
        <p>Cargando datos...</p>
      </div>
    </div>
  );
}
